<template>
  <div class="ui large modal" ref="modal">
    <i class="close icon"></i>
    <div class="header">
      <i class="calendar alternate icon"></i>
      {{ $t("project plan") }}
    </div>
    <div class="image content">
      <!-- <div class="ui small image">
        <img src="/images/icons/gantt.png" style="width: 100% !important" />
      </div> -->
      <div
        class="description"
        style="width: 100% !important; height: 400px !important"
      >
        <gantt style="height: 100% !important" ref="gantt" />
      </div>
    </div>
    <div class="actions">
      <div class="ui red icon right labeled deny button">
        <i class="remove icon"></i>
        {{ $t("close") }}
      </div>
      <div class="ui green icon right labeled button" @click="save">
        <i class="save icon"></i>
        {{ $t("save") }}
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";
import Gantt from "./Gantt";
// import moment from "moment";

export default {
  name: "ProjectPaymentModalIndex",
  components: { Gantt },
  props: {},
  computed: {},
  data() {
    return {
      uuid: "",
    };
  },
  methods: {
    show_modal(data) {
      let vm = this;

      /**
       * get template
       */
      if (data) {
        vm.uuid = data;
        // local_api(vm, "post", "/project/plan/do-get", {
        //   u: data,
        // })
        //   .then((plan) => {
        //     console.log("plan", plan);
        //   })
        //   .catch((err) => {
        //     error_toast(err);
        //   });
      }

      window
        .jQuery(vm.$refs.modal)
        .modal({
          onVisible() {
            // vm.$refs.gantt.checkGantt();
          },
          onHide() {
            vm.uuid = "";
          },
        })
        .modal("show");
    },
    save() {
      let vm = this;

      // let isValid = vm.form.form("validate form");
      // if (isValid) {
      local_api(vm, "post", "/project/plan/do-save", {
        u: vm.uuid,
        d: vm.distribution,
      })
        .then(() => {
          window.jQuery(vm.$refs.modal).modal("hide");
          vm.$emit("success");
        })
        .catch((err) => {
          error_toast(err);
        });
      // }
    },
  },
  mounted() {},
  watch: {},
  updated: function() {},
};
</script>
